/** Formatting shared by the components that print a reading rather than plot one. */

/**
 * A ratio brought back into 0…1, so a caller can hand it straight to a width or a percentage.
 * Anything that is not a finite number — a division by zero, a NaN — reads as 0.
 */
export const clampBetween0And1 = (value: number) => (Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0);

/** A 0…1 ratio as whole percents: `0.564` → `56%`. */
export const formatPercentage = (ratio: number) => `${Math.round(ratio * 100)}%`;

const VALUE_FORMAT = new Intl.NumberFormat('en', { maximumFractionDigits: 1 });

/** A value and the unit it is in, for a reader: `56.25, 'GiB'` → `56.3 GiB`. */
export const formatValueWithUnit = (value: number, unit?: string) =>
  `${VALUE_FORMAT.format(value)}${unit ? ` ${unit}` : ''}`;
